//@ts-nocheck
import React, { useEffect, useRef, useState } from "react";
import { Input } from "../common";
import { Textarea } from "../common/Textarea/Textarea";
import SearchDropdown from "../common/SearchDropdown";
import { useAppSelector } from "../../hooks/useAppSelector";
import DynamicSurveyForm from "./DynamicSurveyForm";
import { useParams } from "react-router-dom";
import WorkExperienceForm from "./WorkExperienceForm";
import EducationDetailsForm from "./EducationDetailsForm";
import FileUpload from "./FileUpload";
import { CalenderIcon } from "../icons";
import CalenderJob from "./CalenderJob";
import LinkInputComponent from "./LinkInputComponent";
import { uploadResume } from "../../services/applicationService";
import { createCandidateApplication } from "../../store/slices/application/applicationSlice";
import { toast } from "sonner";
import { useAppDispatch } from "../../hooks/useAppDispatch";
import ConfettiExplosion from "react-confetti-explosion";
import SkillsInput from "../common/SkillsInput";
import { Link } from "react-router-dom";

const JobApplicationForm = ({ applyJobApplicationData, src, srcby }: any) => {
  const [formData, setFormData] = useState({
    candidate_name: "",
    candidate_email: "",
    candidate_phone_status: "",
    candidate_location: "",
    profile_summary_status: "",
    education_details_status: "",
    work_experience_status: "",
    links: [],
    resume: null,
    cover_letter_status: "",
    skills: [], // Added skills array
  });

  const [yesNoAnswers, setYesNoAnswers] = useState({});
  const [errors, setErrors] = useState<{ [key: string]: string }>({});
  const [selectedCountry, setSelectedCountry] = useState<any>(null);
  const [loadingLocation, setLoadingLocation] = useState(false);
  const locations = useAppSelector((state) => state?.jobs?.locationDetails);
  const [formSteps, setFormSteps] = useState<FormElement[]>([]);
  const [integrationResponse, setIntegrationResponse] = useState<any[]>([]);
  const [showThankYouMessage, setShowThankYouMessage] = useState(false);
  const [loadingForm, setLoadingForm] = useState(false);
  const { base_slug, jobId } = useParams();
  const [uploading, setUploading] = useState(false);
  const [uploadedResumeUrl, setUploadedResumeUrl] = useState<string | null>(
    null
  );
  const [resumeFile, setResumeFile] = useState<File | null>(null);
  const { uploadResumeStatus, createCandidateData, uploadResumeError } =
    useAppSelector((state) => state.application);
  const [resumeError, setResumeError] = useState("");
  const [educationData, setEducationData] = useState([]);
  const [experienceData, setExperienceData] = useState([]);
  const [showConfetti, setShowConfetti] = useState(false);
  const [saveSuccesMessage, setSaveSuccesMessage] = useState("");
  const formRef = useRef<HTMLFormElement>(null);

  const dispatch = useAppDispatch();
  const handleInputChange = (e: any) => {
    const { name, value } = e.target;

    setFormData((prev) => ({
      ...prev,
      [name]: value,
    }));

    validateField(name, value);
  };

  const handleSkillsChange = (skills: string[]) => {
    setFormData((prev) => ({
      ...prev,
      skills: skills,
    }));

    validateField("skills", skills);
  };

  const handleWorkExperienceChange = (e) => {
    // Since the WorkExperienceForm component sends formatted experience data
    const { name, value } = e.target;
    setExperienceData({
      ...experienceData,
      [name]: value,
    });
    setFormData((prev) => ({
      ...prev,
      work_experience_status: value, // The value here will be the formatted array from WorkExperienceForm
    }));

    validateField("work_experience_status", value);
  };

  const handleWorkEducation = (e) => {
    const { name, value } = e.target;
    setEducationData({
      ...educationData,
      [name]: value,
    });
    setFormData((prev) => ({
      ...prev,
      education_details_status: value, // The value here will be the formatted array from WorkExperienceForm
    }));

    validateField("education_details_status", value);
  };
  // const handleEducationChange = (e: any, index: number) => {
  //   const { name, value } = e.target;
  //   const updatedEducation = [...educationData];
  //   updatedEducation[index][name] = value;
  //   setEducationData(updatedEducation);
  //   // Update form data
  //   setFormData(prev => ({
  //     ...prev,
  //     education_details_status: updatedEducation,
  //   }));

  // Function to handle resume parse response and update form
  const handleResumeParseResponse = (responseData: any) => {
    if (!responseData?.data) return;
    const data = responseData.data;
    const firstNumber = data.app_phone_number.split(",")[0];

    // Update basic information
    setFormData((prev) => ({
      ...prev,
      candidate_name: data.app_name || "",
      candidate_email: data.app_email || "",
      candidate_phone_status: firstNumber || "",
      profile_summary_status: data.app_summary?.[0] || "",
      skills: data.skills || [], // Extract skills if available in the parsed data
    }));

    // Update education details
    if (data.app_education?.length > 0) {
      setEducationData(
        data.app_education.map((edu: any) => ({
          degree: edu.course,
          specialization: edu.specialization,
          university: edu.university,
          startDateMonth: edu.start_date_month,
          startDateYear: edu.start_date_year,
          endDateMonth: edu.end_date_month,
          endDateYear: edu.end_date_year,
          location: edu.location,
          grade: edu.grade,
        }))
      );
    }

    // Update experience details
    if (data.experience?.length > 0) {
      setExperienceData(
        data.experience.map((exp: any) => ({
          company: exp.company,
          designation: exp.designation,
          isCurrentJob: exp.isCurrentJob === "true",
          // month and year
          startDateMonth: exp.start_date_month,
          startDateYear: exp.start_date_year,
          endDateMonth: exp.end_date_month,
          endDateYear: exp.end_date_year,
          description: exp.description,

          location: exp.location,
          workplaceType: exp.workplace_type,
        }))
      );
    }

    // Update links if available
    if (data.links && Object.keys(data.links).length > 0) {
      const linksArray = Object.values(data.links).filter((link) => link); // Convert to array and remove empty values
      setFormData((prev) => ({
        ...prev,
        links: linksArray, // Store as an array instead of a string
      }));
    }

    // Update skills and projects if needed
    // You might want to add these to your form state if you have fields for them
    // if (data.skills?.length > 0) {
    //   // Handle skills
    // }

    // if (data.projects?.length > 0) {
    //   // Handle projects
    // }
  };

  const validateField = (name: string, value: any) => {
    let errorMessage = "";

    // Only validate if the field is required according to API response
    switch (name) {
      case "candidate_name":
        if (applyJobApplicationData.application.candidate_name === "required") {
          if (!value?.trim()) errorMessage = "Name is required";
        }
        break;

      // case 'candidate_email':
      //   if (applyJobApplicationData.application.candidate_email === 'required') {
      //     if (!value?.trim()) {
      //       errorMessage = 'Email is required';
      //     } else if (!/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value)) {
      //       errorMessage = 'Invalid email format';
      //     }
      //   }
      //   break;
      case "candidate_phone_status":
        if (
          applyJobApplicationData.application.candidate_phone_status ===
          "required"
        ) {
          if (!value?.trim()) {
            errorMessage = "Phone number is required";
          }
          //  else if (!/^[\d+ ]{1,20}$/.test(value)) {
          //   errorMessage = 'Invalid phone number';
          // }
          else if (!/^[\d+\- ]{1,20}$/.test(value)) {
            errorMessage = "Invalid phone number";
          }
        }
        break;
      case "candidate_location":
        if (
          applyJobApplicationData.application.candidate_location_status ===
          "required"
        ) {
          if (!value?.trim()) errorMessage = "Location is required";
        }
        break;

      case "profile_summary_status":
        if (
          applyJobApplicationData.application.profile_summary_status ===
          "required"
        ) {
          if (!value?.trim()) errorMessage = "Profile summary is required";
        }
        break;

      case "education_details_status":
        if (
          applyJobApplicationData.application.education_details_status ===
          "required"
        ) {
          // Check if value is an array and has at least one entry with required fields
          if (!Array.isArray(value) || value.length === 0) {
            errorMessage = "Education details are required";
          } else {
            // Check if at least one experience entry has the required fields
            const hasValidExperience = value.some(
              (exp) =>
                exp.course?.trim() &&
                exp.branch?.trim() &&
                exp.startDateMonth?.trim() &&
                exp.startDateYear?.trim() &&
                exp.university?.trim() &&
                exp.location?.trim() &&
                exp.grade?.trim()
            );

            // if (!hasValidExperience) {
            //   errorMessage = 'Please complete at least one work experience entry';
            // }
          }
        }
        break;

      case "work_experience_status":
        if (
          applyJobApplicationData.application.work_experience_status ===
          "required"
        ) {
          // Check if value is an array and has at least one entry with required fields
          if (!Array.isArray(value) || value.length === 0) {
            errorMessage = "Work experience is required";
          } else {
            // Check if at least one experience entry has the required fields
            const hasValidExperience = value.some(
              (exp) =>
                exp.company?.trim() &&
                exp.designation?.trim() &&
                exp.startDateMonth?.trim() &&
                exp.startDateYear?.trim()
            );

            // if (!hasValidExperience) {
            //   errorMessage = 'Please complete at least one work experience entry';
            // }
          }
        }
        break;

      case "skills":
        if (applyJobApplicationData.application.skills_status === "required") {
          if (!Array.isArray(value) || value.length === 0) {
            errorMessage = "At least one skill is required";
          }
        }
        break;

      case "links":
        if (applyJobApplicationData.application.links_status === "required") {
          if (!value || value.length === 0) {
            errorMessage = "At least one link is required";
          }
          // else if (!value.every(link => /^https?:\/\/\S+$/.test(link))) {
          //   errorMessage = 'All links must be valid URLs';
          // }
        }
        break;

      // case 'links':
      //   if (applyJobApplicationData.application.links_status === 'required') {
      //     if (!value?.trim()) {
      //       errorMessage = 'Links are required';
      //     } else if (value?.trim() && !/^https?:\/\/\S+$/.test(value)) {
      //       errorMessage = 'Enter a valid URL';
      //     }
      //   }
      //   break;

      case "resume":
        if (
          applyJobApplicationData.application.resume_upload_status ===
          "required"
        ) {
          if (!value) errorMessage = "Resume is required";
        }
        break;

      case "cover_letter_status":
        if (
          applyJobApplicationData.application.cover_letter_status === "required"
        ) {
          if (!value?.trim()) errorMessage = "Cover letter is required";
        }
        break;

      default:
        break;
    }

    setErrors((prev) => ({
      ...prev,
      [name]: errorMessage,
    }));

    return errorMessage;
  };

  const handleFileChange = async (e: React.ChangeEvent<HTMLInputElement>) => {
    const file = e.target.files?.[0];
    if (file) {
      setResumeFile(file);

      // Ensure applyJobApplicationData exists and has an application.id
      if (!applyJobApplicationData?.application?.id) {
        console.error("Missing app_id in applyJobApplicationData");
        return;
      }

      await uploadResumeToServer(
        file,
        jobId,
        base_slug,
        applyJobApplicationData
      );
    }
  };

  const uploadResumeToServer = async (
    file: File,
    jobId: string,
    base_slug: string,
    applyJobApplicationData: { application: { id: string } }
  ) => {
    setUploading(true);
    setResumeError();

    const formData = new FormData();
    formData.append("resume", file);
    formData.append("job_id", jobId);
    formData.append("base_slug", base_slug);
    formData.append("app_id", applyJobApplicationData.app_id);
    formData.append("email", applyJobApplicationData.candidate_email);

    try {
      const response = await uploadResume(
        file,
        jobId,
        base_slug,
        applyJobApplicationData.app_id,
        applyJobApplicationData.candidate_email
      );
      setUploadedResumeUrl(response);
      // Handle the parse response
      if (response?.data) {
        handleResumeParseResponse(response);
      }
    } catch (error: any) {
      setResumeError(error.response?.data?.status);
    } finally {
      setUploading(false);
    }
  };

  const handleSubmit = (e: any) => {
    e.preventDefault();

    // Validate all fields before submission
    const formErrors: { [key: string]: string } = {};
    let hasErrors = false;

    Object.keys(formData).forEach((key) => {
      const error = validateField(key, formData[key as keyof typeof formData]);
      if (error) {
        hasErrors = true;
      }
    });

    if (hasErrors) {
      return;
    }

    // Proceed with form submission
    // console.log('Form Data:', formData);
  };

  // const handleYesNoChange = (questionId, value) => {
  //   setYesNoAnswers(prev => ({
  //     ...prev,
  //     [questionId]: value
  //   }));
  // };

  const handleCountryChange = async (country: any) => {
    setSelectedCountry(country);
  };

  const handleLinksChange = (links) => {
    setFormData((prev) => ({
      ...prev,
      links: links,
    }));

    validateField("links", links); // Ensure validation runs
  };

  const handleSubmitApplication = async (dynamicFormData: any) => {
    setErrors({});
    let hasErrors = false;
    const allErrors: { [key: string]: string } = {};

    // Validate all required fields
    Object.keys(applyJobApplicationData.application).forEach((key) => {
      if (applyJobApplicationData.application[key] === "required") {
        const value = formData[key as keyof FormData];
        const error = validateField(key, value);
        if (error) {
          window.scrollTo({
            top: 0,
            behavior: "smooth",
          });
          hasErrors = true;
          allErrors[key] = error;
        }
      }
    });

    if (hasErrors) {
      toast.error("Please fill all required fields");
      formRef.current?.scrollIntoView({ behavior: "smooth", block: "start" });
      setErrors(allErrors);
      return;
    }

    try {
      setLoadingForm(true);
      const applicationResponse = await dispatch(
        createCandidateApplication({
          job_id: jobId,
          base_slug,
          app_candidate_id: applyJobApplicationData.app_id,
          app_name: formData.candidate_name,
          app_email: applyJobApplicationData.candidate_email,
          // app_email: applyJobApplicationData.candidate_email,
          app_phone_number: formData.candidate_phone_status,
          app_location: selectedCountry?.locationName,
          app_summary: formData.profile_summary_status,
          app_education: JSON.stringify(educationData),
          app_work: JSON.stringify(experienceData),
          app_links: formData.links.join(","),
          skills: formData.skills.join(","),
          app_cover_letter: formData.cover_letter_status,
          app_status: "submitted",
          answers: dynamicFormData.answers,
          app_source: src ? src : "Organic",
          app_source_by: srcby ? srcby : "Self",
        })
      ).unwrap();

      // Combine all form data
      const completeFormData = {
        ...formData,
        ...dynamicFormData,
        applicationId: applicationResponse.id,
      };

      setSaveSuccesMessage(applicationResponse);
      setShowThankYouMessage(true);
      // setShowConfetti(true);
      toast.success("Application submitted successfully!");

      // Reset form after successful submission
      setFormData({
        candidate_name: "",
        candidate_email: "",
        candidate_phone_status: "",
        candidate_location: "",
        profile_summary_status: "",
        education_details_status: "",
        work_experience_status: "",
        links: [],
        resume: null,
        cover_letter_status: "",
        skills: [],
      });
    } catch (error: any) {
      console.error("Application submission error:", error);
      toast.error(
        error.message || "Failed to submit application. Please try again."
      );
    } finally {
      setLoadingForm(false);
    }
  };

  // const handleSubmitApplication = async (dynamicFormData: any) => {

  //   // Validate all fields before submission
  //   let hasErrors = false;
  //   const allErrors: { [key: string]: string } = {};

  //   // Validate all form fields
  //   Object.keys(formData).forEach(key => {
  //     console.log(key,"keykey");

  //     toast.error('Please fill in all required fields')
  //     const error = validateField(key, formData[key as keyof typeof formData]);
  //     console.log(error, "error");

  //     if (error) {
  //       hasErrors = true;
  //       allErrors[key] = error;
  //     }
  //   });
  //   Object.keys(formData).forEach(key => {
  //     if (applyJobApplicationData.application[key] === 'required') {
  //       const error = validateField(key, formData[key as keyof typeof formData]);
  //       if (error) {
  //         allErrors[key] = error;
  //         hasErrors = true;
  //       }
  //     }
  //   });

  //   // If there are any validation errors, stop submission
  //   if (hasErrors) {
  //     toast.error('Please fill all required fields');
  //     formRef.current?.scrollIntoView({
  //       behavior: 'smooth',
  //       block: 'start'
  //     });
  //     setErrors(allErrors);
  //     return;
  //   }

  //   try {
  //     // First create the application
  //     const applicationResponse = await dispatch(createCandidateApplication({
  //       job_id: jobId,
  //       base_slug,
  //       app_candidate_id: applyJobApplicationData.app_id,
  //       app_name: formData.candidate_name,
  //       app_email: applyJobApplicationData.candidate_email,
  //       app_phone_number: formData.candidate_phone_status,
  //       app_location: selectedCountry?.locationName,
  //       app_summary: formData.profile_summary_status,
  //       app_education: JSON.stringify(educationData),
  //       app_work: JSON.stringify(experienceData),
  //       app_links: formData.links.toString(),
  //       app_cover_letter: formData.cover_letter_status,
  //       answers: dynamicFormData.answers
  //     })).unwrap();

  //     // Combine all form data
  //     const completeFormData = {
  //       ...formData,
  //       ...dynamicFormData,
  //       applicationId: applicationResponse.id
  //     };

  //     setSaveSuccesMessage(applicationResponse);
  //     setShowThankYouMessage(true);

  //     toast.success('Application submitted successfully!');
  //   } catch (error) {
  //     console.error(error, " errorrr");
  //     window.scrollTo({
  //       top: 0,
  //       behavior: 'smooth'
  //     });
  //     toast.error('Failed to submit application. Please try again.');
  //   }
  // };

  const formatDate = (isoString: string) => {
    const date = new Date(isoString);
    return new Intl.DateTimeFormat("en-GB", {
      day: "2-digit",
      month: "short",
      year: "numeric",
    }).format(date);
  };

  const handlePhoneInputChange = (e) => {
    const { name, value } = e.target;

    // Only allow phone number characters: digits, +, -, spaces, parentheses, dots
    const phonePattern = /^[+\-\s\d\(\)\.]*$/;

    // Check if valid characters and within length limit
    if (phonePattern.test(value) && value.length <= 18) {
      // If valid characters and within limit, update the state
      setFormData((prev) => ({
        ...prev,
        [name]: value,
      }));
      validateField(name, value);
    }
    // If invalid characters or exceeds length, ignore the input (don't update state)
  };

  return (
    <>
      {applyJobApplicationData.app_status === "draft" && (
        <>
          {!showThankYouMessage && (
            <form onSubmit={handleSubmit} className="space-y-8" ref={formRef}>
              <div className="space-y-6">
                {/* Personal Information */}
                <div className="space-y-4">
                  <h3 className="text-lg font-semibold">
                    Personal Information
                  </h3>
                  <div className="grid grid-cols-1 md:grid-cols-1 gap-4">
                    <FileUpload
                      label="Resume"
                      name="resume"
                      onChange={handleFileChange}
                      error={resumeError}
                      required={
                        applyJobApplicationData.application.resume_upload_status
                      }
                      accept=".pdf,.doc,.docx"
                      isUploading={uploading}
                      resume={uploadedResumeUrl}
                    />
                    <Input
                      label="Full Name"
                      id="candidate_name"
                      name="candidate_name"
                      placeholder="Full Name"
                      value={formData.candidate_name}
                      onChange={handleInputChange}
                      error={errors.candidate_name}
                      required={
                        applyJobApplicationData.application.candidate_name
                      }
                    />

                    <label
                      htmlFor="email"
                      className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium"
                    >
                      Email
                    </label>
                    <div className="!mt-[-0.5rem]">
                      <input
                        id="candidate_email"
                        placeholder="Email"
                        name="candidate_email"
                        // disabled
                        // value={formData.candidate_email}
                        disabled
                        value={applyJobApplicationData.candidate_email}
                        // onChange={handleInputChange}
                        error={errors.candidate_email}
                        required={
                          applyJobApplicationData.application.candidate_email
                        }
                        className="block w-full rounded-md bg-white px-3 py-2  text-[14px]  text-gray-900 outline outline-0 border-[#d1d5db] -outline-offset-2 outline-gray-300 placeholder:text-gray-400 focus:outline input_hover disabled:cursor-not-allowed disabled:bg-gray-50 disabled:text-gray-500 disabled:outline-gray-300 sm:text-sm/6"
                      />
                    </div>

                    <Input
                      label="Phone Number"
                      placeholder="Phone Number"
                      id="candidate_phone_status"
                      type="tel"
                      name="candidate_phone_status"
                      value={formData.candidate_phone_status}
                      onChange={handlePhoneInputChange}
                      error={errors.candidate_phone_status}
                      required={
                        applyJobApplicationData.application
                          .candidate_phone_status
                      }
                    />
                    <div className="flex flex-col gap-y-2 mt-1">
                      <label className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">
                        Location
                      </label>
                      <div className="relative">
                        <SearchDropdown
                          items={locations}
                          buttonText="Search by city, state, or country"
                          onChange={handleCountryChange}
                          selectedItem={selectedCountry}
                          isLoading={loadingLocation}
                        />
                      </div>
                    </div>
                  </div>
                </div>

                {/* Profile Summary */}
                <Textarea
                  label="Profile Summary"
                  placeholder="Profile Summary"
                  id="profile_summary_status"
                  name="profile_summary_status"
                  value={formData.profile_summary_status}
                  onChange={handleInputChange}
                  error={errors.profile_summary_status}
                  required={
                    applyJobApplicationData.application.profile_summary_status
                  }
                  rows={5}
                />

                {/* Education & Experience */}
                <div className="space-y-2 md:space-y-4 lg:space-y-4">
                  <div className="flex justify-between items-start mb-0 mb:mb-4 lg:mb-4">
                    <h4 className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">
                      Education Details
                      {applyJobApplicationData.application
                        .education_details_status === "required" && (
                        <span className="text-red-500 ml-1">*</span>
                      )}
                    </h4>
                  </div>
                  <EducationDetailsForm
                    value={formData.education_details_status}
                    onChange={handleWorkEducation}
                    initialData={educationData}
                    error={errors.education_details_status}
                    required={
                      applyJobApplicationData.application
                        .education_details_status
                    }
                  />
                </div>

                <div className="space-y-4">
                  <div className="flex justify-between items-start mb-4">
                    <h4 className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">
                      Experience Details
                      {applyJobApplicationData.application
                        .work_experience_status === "required" && (
                        <span className="text-red-500 ml-1">*</span>
                      )}
                    </h4>
                  </div>
                  <WorkExperienceForm
                    value={formData.work_experience_status}
                    onChange={handleWorkExperienceChange}
                    initialData={experienceData}
                    error={errors.work_experience_status}
                    required={
                      applyJobApplicationData.application.work_experience_status
                    }
                  />
                </div>
                {/* Links & Documents */}
                <div className="space-y-4">
                  <div className="wg-label capitalize inline-flex shrink-0 items-center gap-1 text-[13px] md:text-[14px] lg:text-[14px] text-[#2f2f31] wg-antialiased leading-4 md:leading-5 lg:leading-5 font-medium">
                    Add link
                    {applyJobApplicationData.application.links_status ===
                      "required" && (
                      <span className="text-red-500 ml-1">*</span>
                    )}
                  </div>
                  <LinkInputComponent
                    onChange={handleLinksChange}
                    links={
                      typeof formData.links === "string"
                        ? formData.links.split(", ")
                        : formData.links || []
                    }
                    error={errors.links}
                    required={applyJobApplicationData.application.links_status}
                  />

                  <Textarea
                    label="Cover Letter"
                    id="cover_letter_status"
                    name="cover_letter_status"
                    value={formData.cover_letter_status}
                    onChange={handleInputChange}
                    rows={4}
                    error={errors.cover_letter_status}
                    required={
                      applyJobApplicationData.application.cover_letter_status
                    }
                  />
                  {/* Skills Section */}
                  <div className="space-y-2 md:space-y-4 lg:space-y-4">
                    <SkillsInput
                      value={formData.skills}
                      onChange={handleSkillsChange}
                      required={
                        applyJobApplicationData.application.skills_status ===
                        "required"
                      }
                      error={errors.skills}
                    />
                  </div>
                </div>

                {/* Additional Questions */}
                {/* {applyJobApplicationData?.data?.applicationQuestion?.map((question) => (
            <div key={question.id} className="space-y-2">
              <Label>{question.question_title}</Label>
              {question.question_input_type === 'yes-no' && (
                <RadioGroup
                  onValueChange={(value) => handleYesNoChange(question.id, value)}
                  value={yesNoAnswers[question.id]}
                >
                  {JSON.parse(question.question_input_option).map((option, index) => (
                    <div key={index} className="flex items-center space-x-2">
                      <RadioGroupItem value={option} id={`${question.id}-${index}`} />
                      <Label htmlFor={`${question.id}-${index}`}>{option}</Label>
                    </div>
                  ))}
                </RadioGroup>
              )}
            </div>
          ))} */}
              </div>

              {/* <hr className="mt-6 !mb-[-20px]" /> */}
              {/* <p className='mt-[-10px] block items-center uppercase rounded-lg bg-transparent text-dark-black-200 font-[500] text-[0.8125rem] focus:outline-none justify-start'>
            Share us your Feedback
          </p> */}

              {/* {
            applyJobApplicationData.applicationQuestion.length > 0 && */}
              <div
                className="!pt-0 !mt-2"
                className={`${
                  applyJobApplicationData.applicationQuestion.length > 0
                    ? "pt-0 !mt-[-1rem]"
                    : "!pt-0 !mt-2"
                }`}
              >
                <DynamicSurveyForm
                  steps={applyJobApplicationData?.applicationQuestion}
                  formSteps={formSteps}
                  // submitStepIntegrationResponse={handleSubmitStepIntegrationResponse}

                  // formikHandleBlur={formikHandleBlur}
                  // setFieldTouched={setFieldTouched}
                  // values={values}
                  onSubmit={handleSubmitApplication}
                  integrationResponse={integrationResponse}
                  setIntegrationResponse={setIntegrationResponse}
                  setShowThankYouMessage={setShowThankYouMessage}
                  showThankYouMessage={showThankYouMessage}
                  setLoadingForm={setLoadingForm}
                  loadingForm={loadingForm}
                  parentFormData={formData}
                />
              </div>
              {/* } */}

              {/* <div className="mt-6 flex justify-center">
      <button
        type="submit"
        className="rounded-md bg-indigo-600 w-auto px-2.5 py-2 text-sm font-semibold text-white shadow-sm hover:bg-indigo-500 focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-indigo-600"
      >
        Submit Application
      </button>
    </div> */}
            </form>
          )}
        </>
      )}

      {applyJobApplicationData.app_status === "submitted" && (
        <>
          <div className="mt-[50px] mb-[6rem] p-4 bg-green-100 text-green-800 border border-green-300 rounded-md relative">
            <div className="flex items-center gap-x-4">
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                strokeWidth={1.5}
                stroke="currentColor"
                className="size-7"
              >
                <path
                  strokeLinecap="round"
                  strokeLinejoin="round"
                  d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
                />
              </svg>
              <div className="flex flex-col items-start gap-y-1 w-full">
                <div className="block w-full">
                  <span className="text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-fit p-0 mt-0">
                    Application ID:
                    <span className="mx-1">
                      {" "}
                      {applyJobApplicationData?.app_id}
                    </span>
                  </span>

                  <Link
                    to={`/${base_slug}/${jobId}/app/${applyJobApplicationData?.app_id}/details`}
                    className="ml-1 text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-blue-800 w-full p-0 mt-0"
                  >
                    {`[View Application]`}
                  </Link>
                </div>
                {applyJobApplicationData?.app_updated_at && (
                  <p className="text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-full p-0 mt-0">
                    Received on :{" "}
                    <span>
                      {formatDate(applyJobApplicationData?.app_updated_at)}
                    </span>
                  </p>
                )}
              </div>
            </div>
            <h4 className=" text-green-800 my-[8px] lg:my-[4px] h-[100%] w-full p-0 text-[16px] md:text-[16px] lg:text-[16px] leading-5 lg:leading-[30px] font-medium flex items-start md:items-center lg:items-center gap-2">
              Thank you! Your application has been submitted successfully.
            </h4>
            <p className="text-[16px] md:text-[16px] lg:text-[16px] leading-6 font-normal text-green-800 w-full p-0 m-0">
              Our team will review it, and we'll get back to you soon.
            </p>
            {showThankYouMessage && (
              <div className="flex justify-center items-center absolute inset-0">
                <ConfettiExplosion />
              </div>
            )}
          </div>
        </>
      )}

       {applyJobApplicationData.app_status === 'deleted' &&
      <>
        <div className="mt-[50px] mb-[34px] p-4 bg-red-100 text-red-800 border border-red-300 rounded-md relative">
          <div className='flex items-center gap-x-4'>
            <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-6 lg:size-7">
              <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z" />
            </svg>
            <div className='flex flex-col items-start gap-y-1'>
              <span className='text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-red-800 w-full p-0 mt-0'>
                Application ID : <span className='ml-1'>  {applyJobApplicationData?.app_id}</span>
              </span>
              <p className='text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-red-800 w-full p-0 mt-0'>
                Received on : <span>{formatDate(applyJobApplicationData?.app_updated_at)}</span>
              </p>
            </div>
          </div>
          <h4 className=' text-red-800 my-[8px] lg:my-[4px] h-[100%] w-full p-0 text-[16px] md:text-[16px] lg:text-[16px] leading-5 lg:leading-[30px] font-medium flex items-start md:items-center lg:items-center gap-2'>
            This application has been deleted.
          </h4>
          <p className='text-[16px] md:text-[16px] lg:text-[16px] leading-6 font-normal text-red-800 w-full p-0 m-0'>
            This application is no longer available. If you believe this was removed in error, please contact the employer or reapply.
          </p>


        
        </div></>
}

      {showThankYouMessage && (
        <div className="mt-[50px] mb-[34px] p-4 bg-green-100 text-green-800 border border-green-300 rounded-md relative">
          <div className="flex items-center gap-x-4">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              strokeWidth={1.5}
              stroke="currentColor"
              className="size-6 lg:size-7"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                d="M9.813 15.904 9 18.75l-.813-2.846a4.5 4.5 0 0 0-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 0 0 3.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 0 0 3.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 0 0-3.09 3.09ZM18.259 8.715 18 9.75l-.259-1.035a3.375 3.375 0 0 0-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 0 0 2.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 0 0 2.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 0 0-2.456 2.456ZM16.894 20.567 16.5 21.75l-.394-1.183a2.25 2.25 0 0 0-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 0 0 1.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 0 0 1.423 1.423l1.183.394-1.183.394a2.25 2.25 0 0 0-1.423 1.423Z"
              />
            </svg>
            <div className="flex flex-col items-start gap-y-1">
              <span className="text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-full p-0 mt-0">
                Application ID:
                <span className="ml-1"> {saveSuccesMessage?.data?.id}</span>
              </span>
              <p className="text-[13px] md:text-[13px] lg:text-[13px] leading-4 font-normal text-green-800 w-full p-0 mt-0">
                Received on :{" "}
                <span>{formatDate(saveSuccesMessage?.data?.updated_at)}</span>
              </p>
            </div>
          </div>
          <h4 className=" text-green-800 my-[8px] lg:my-[4px] h-[100%] w-full p-0 text-[16px] md:text-[16px] lg:text-[16px] leading-5 lg:leading-[30px] font-medium flex items-start md:items-center lg:items-center gap-2">
            Thank you! Your application has been submitted successfully.
          </h4>
          <p className="text-[16px] md:text-[16px] lg:text-[16px] leading-6 font-normal text-green-800 w-full p-0 m-0">
            Our team will review it, and we'll get back to you soon.
          </p>

          {showThankYouMessage && (
            <div className="flex justify-center items-center absolute inset-0">
              <ConfettiExplosion />
            </div>
          )}
        </div>
      )}
    </>
  );
};

export default JobApplicationForm;
